import {Component, Input, OnInit} from '@angular/core';
import {ControlContainer, UntypedFormControl, NgForm, Validators} from '@angular/forms';
import {ICompanyInfo} from "../../../message-models/company-info.interface";

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class CompanyDetailsComponent implements OnInit {

  @Input() company: ICompanyInfo = {} as ICompanyInfo;
  @Input() editing: boolean = false;
  email: UntypedFormControl;
  constructor() { }

  ngOnInit(): void {
  }
  validateEmail(email) {
    this.email = new UntypedFormControl(email,
      [Validators.email, Validators.pattern('^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')]);
    if (this.editing) {
      return this.email.valid;
    } else {
      return true;
    }
  }
  lookupPostcode() {

  }
}
